<script>
/* eslint-disable */
import { mapGetters } from "vuex"
import { v4 as uuidv4 } from 'uuid'
import AutoCueItem from "./AutoCueItem.vue";
import Move from './Move.vue';


export default {
  name: "AutoCueList",
  components: {
    AutoCueItem,
    Move
  },
  computed: {
    ...mapGetters({
      scriptOpened: "scripts/scriptOpened",
      hasMoreThanOneCircuits: "scripts/hasMoreThanOneCircuits",
      hasCircuits: "scripts/hasCircuits",
      cueItems: "scripts/cueItems"
    }),
    fillerList:{
      get(){
        const items = this.items
        const newItems = []
        if (items.length < 9) {
          const diff = 9 - items.length
          for (let i=0;i<diff;i++) {
            newItems.push({type: 'filler', id: uuidv4()})
          }
        }
        return newItems
      },
    }
  },
  methods: {
    onDragStart() {
      setDragCursor(true)
    },
    onDragEnd() {
      setDragCursor(false)
    },
  }
  
};
</script>


<style scoped>
.circuit-list {
  border-top: 5px solid #707070;
  margin: 0;
  padding: 0;
  position: relative;
}
.pointer {
  position: absolute;
  top: 200px;
  left: 40vw;
}
.note {
  position: absolute;
  top: 20px;
  left: 40vw;
  text-align: center;
}
.works-reps {
  position: absolute;
  top: 16px;
  right: 0;
  width: 250px;
}

.reps{
  font-family: 'Times New Roman', Times, serif;
  font-size: 1.5rem;
  font-weight: 600;
  margin-top: -5px;
  text-align: right;
}

.checkbox .round {
  margin-left: 1rem;
}

.separator {
  display: flex;
  justify-content: center;
  align-items: center;
}
.separator span {
  font-weight: 600;
  font-size: 20px;
}
</style>

<template>
  <div class="circuit-list">
    <div class="note" v-if="!hasCircuits">
      <h3>Start adding items to view auto cue mode</h3>
    </div>
    <div v-if="hasCircuits">
      <auto-cue-item v-for="(item, index) in cueItems" :key="index" :order="index+1" :item="item"></auto-cue-item>
    </div>
  </div>
</template>